import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/tokens.css';
import './styles/base.css';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('#root fehlt im HTML');

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
